import { dirSign } from '../utils/motion.js';

/**
 * Each .press-sheet section: text slides/fades in, and its
 * .registration-image (4 stacked CMYK layers) snaps from a misaligned
 * offset print into perfect registration as the section centers in view.
 * This is the "images/sections load out of alignment, then snap true"
 * signature moment — literally how offset printing works.
 */
export function initPressSheets(gsap, ScrollTrigger) {
  const sheets = gsap.utils.toArray('.press-sheet');
  if (!sheets.length) return;

  sheets.forEach((sheet) => {
    const copy = sheet.querySelectorAll('.service-block__number, .service-block__title, .service-block p, .service-block .spec-line, .service-block .btn');
    const image = sheet.querySelector('.registration-image');
    const layers = sheet.querySelectorAll('.registration-image__layer');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sheet,
        start: 'top 70%',
        end: 'top 30%',
        scrub: false,
        toggleActions: 'play none play reverse',
      },
    });

    tl.from(copy, {
      x: 40 * dirSign(),
      opacity: 0,
      duration: 0.5,
      stagger: 0.08,
      ease: 'power3.out',
    });

    if (image && layers.length) {
      const misalign = [
        { x: -22, y: -14, rotate: -2 },
        { x: 18, y: -10, rotate: 1.5 },
        { x: -14, y: 16, rotate: -1 },
        { x: 10, y: 10, rotate: 0.8 },
      ];
      gsap.set(image, { opacity: 1 });
      tl.from(
        layers,
        {
          x: (i) => misalign[i % 4].x,
          y: (i) => misalign[i % 4].y,
          rotate: (i) => misalign[i % 4].rotate,
          scale: 1.08,
          duration: 0.7,
          stagger: 0.05,
          ease: 'power3.out',
        },
        '<0.1'
      );
      
      tl.to(
        layers,
        {
          '--gray': 0,
          duration: 1.0,
          ease: 'power2.inOut',
        },
        '+=0.2'
      );
    }

    // Subtle parallax on the image while the section is in view (adds depth
    // without full scroll-jacking, keeps it performant on mobile too)
    if (image) {
      gsap.to(image, {
        yPercent: -8,
        ease: 'none',
        scrollTrigger: {
          trigger: sheet,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6,
        },
      });
    }
  });
}
